{
  "$schema": "./schema.json",
  "bankID": {
    "common": {
      "startBankId": "Tunnistaudu",
      "pleaseWait": "Odota hetki...",
      "canceledTitle": "Peruutettu",
      "loginCancelled": "Todennus peruutettiin",
      "authenticationError": "Todennus epäonnistui. Yritä uudelleen.",
      "back": "Takaisin",
      "continue": "Jatka",
      "cancel": "Peruuta"
    },
    "SE": {
      "startBankId": "Tunnistaudu",
      "writeSecurityCode": "Skannaa QR-koodi tai syötä turvakoodi",
      "autostartTitle": "Avataan BankID...",
      "autostartDescription": "BankID-sovellus avautuu automaattisesti. Seuraa sovelluksen ohjeita.",
      "bankIdOnThisDevice": "Käytä BankID:tä tällä laitteella",
      "bankIdOnAnotherDevice": "Käytä BankID:tä toisella laitteella",
      "bankIdTestFlow": "Testivirta (henkilötunnuksella)",
      "qrCodeInstructions": "Näin käytät:",
      "qrCodeStep1": "Avaa BankID-sovellus mobiililaitteellasi",
      "qrCodeStep2": "Napauta 'Skannaa QR-koodi'",
      "qrCodeStep3": "Osoita kamera yllä olevaan QR-koodiin",
      "qrCodeStep4": "Seuraa BankID-sovelluksen ohjeita",
      "abortLogin": "Peruuta todennus",
      "ssn": "Henkilötunnus",
      "ssnHelper": "Syötä ruotsalainen henkilötunnuksesi",
      "ssnPlaceholder": "VVVVKKPP-XXXX",
      "giveValidSSN": "Anna kelvollinen henkilötunnus"
    },
    "FI": {
      "selectBank": "Valitse pankkisi",
      "authInProgress": "Todennus käynnissä",
      "authInProgressDescription": "Suorita todennus ponnahdusikkunassa tai uudessa välilehdessä. Älä sulje tätä ikkunaa.",
      "noBankIdInfo": "Eikö sinulla ole BankID:tä?",
      "getBankIdLink": "Hanki BankID täältä"
    },

    "errors": {
      "genericError": "Todennus epäonnistui. Yritä uudelleen.",
      "userCancelled": "Peruutit todennuksen.",
      "unauthorized": "Sinulla ei ole pääsyä tähän palveluun",
      "timeout": "Todennus aikakatkaistiin. Yritä uudelleen.",
      "startFailed": "Todennuksen aloittaminen epäonnistui. Yritä uudelleen.",
      "popupBlocked": "Selain esti ponnahdusikkunan. Salli ponnahdusikkunat ja yritä uudelleen.",
      "networkError": "Verkkovirhe. Tarkista yhteytesi ja yritä uudelleen."
    }
  }
}
